import React from 'react';
import T from 'prop-types';
// components
import Button from 'components/Button';
import Typography from 'components/Typography';
import Modal from 'components/Modal';
// styles
import classnames from 'classnames/bind';
import styles from './RemoveModal.module.scss';

const cx = classnames.bind(styles);

const RemoveModal = ({ subject = '', onConfirm, ...props }) => {
  return (
    <Modal {...props}>
      <div className={cx('wrapper')}>
        <Typography type="h4">
          Are you sure you wish to remove <strong>{subject}</strong>?
        </Typography>
        <Button className={cx('confirm-button', 'mgt-30')} label="REMOVE" onClick={onConfirm} />
      </div>
    </Modal>
  );
};

RemoveModal.propTypes = {
  subject: T.string,
  onConfirm: T.func,
};

export default RemoveModal;
